import './pageNotFound.css';

export const PageNotFound = () => {
  return (
    <div className="error_new">
      <div className="container-fluid">
        <div className="col-xs-12 ground-color text-center">
          <div className="container-error-404">
            <div className="clip"><div className="shadow"><span className="digit">4</span></div></div>
            <div className="clip"><div className="shadow"><span className="digit">0</span></div></div>
            <div className="clip"><div className="shadow"><span className="digit">4</span></div></div>
            <div className="msg">OH!<span className="triangle"></span></div>
          </div>
          <h2 className="h1 me-4">La página que buscas no existe.</h2>
        </div>
      </div>
    </div>
  );
};

